export default __webpack_public_path__ + "static/media/Wolf's Jerkin of the Grasping Wild.0ca84b93.jpg";